import merge from 'classnames';

import { IconDone } from '@/components/icons/IconDone/IconDone';
import { IconWarning } from '@/components/icons/IconWarning/IconWarning';
import { StatusCode, STATUSES_MAP } from '@/constants/statuses';

import styles from './ContentCard.module.scss';

export type StatusProps = {
  code?: StatusCode | null;
  className?: string;
  testId?: string;
};

const IconsMap = {
  done: (color: string) => <IconDone classes={{ container: styles.icon }} color={color} />,
  warning: (color: string) => <IconWarning classes={{ container: styles.icon }} color={color} />,
};

export const Status = ({ code, className, testId }: StatusProps) => {
  if (!code || code === StatusCode.NoStatus || code === StatusCode.Received) return null;

  const { icon, title, mainColor, backgroundColor } = STATUSES_MAP[code];
  const fontColor = mainColor === backgroundColor ? '#fff' : mainColor;

  return (
    <div
      className={merge(styles.status, className)}
      data-testid={testId ?? 'content-card-status'}
      style={{
        color: fontColor,
        borderColor: mainColor,
        backgroundColor: backgroundColor,
      }}
    >
      {icon && IconsMap[icon](fontColor)}
      <span>{title}</span>
    </div>
  );
};
